import type { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { TellentMentionableActions } from './mentionables.store';
import { TellentNotesHttpClient } from '../notes/notes-http-client';
import { getTellentNoteScope } from '../notes/notes.store';

@Injectable({ providedIn: 'root' })
export class TellentMentionableEffects {
  private readonly tellentNotesHttpClient = inject(TellentNotesHttpClient);
  private readonly actions$ = inject(Actions);

  public fetchCollection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentMentionableActions.fetchCollection),
      switchMap(({ payload }) =>
        this.tellentNotesHttpClient
          .fetchMentionables(payload.resourceType, payload.resourceId)
          .pipe(
            mergeMap(members => [
              TellentMentionableActions.fetchCollectionSuccess({
                payload: {
                  data: members,
                  scope: getTellentNoteScope(payload.resourceType, payload.resourceId),
                },
              }),
            ]),
            catchError((error: HttpErrorResponse) =>
              of(
                TellentMentionableActions.fetchCollectionFailed({
                  payload: {
                    error,
                    scope: getTellentNoteScope(payload.resourceType, payload.resourceId),
                  },
                }),
              ),
            ),
          ),
      ),
    ),
  );
}
